import React from 'react';
import _ from 'lodash';

import Ride from './Ride';

class Rides extends React.Component {

	render() {

		return (
			<ul className={ `rides-list ${ this.props.singleRide ? 'single-filtered' : '' }` }>

				{ this.props.rides.length > 0 &&
					this.props.rides.map((ride, i) => <Ride ride={ ride } singleRide={ this.props.singleRide } key={ i } />)
				}

				{ this.props.rides.length === 0 &&
					<p>There aren't any leisure rides that meet all of the above filter selections.</p>
				}

			</ul>
		)
	}
}

export default Rides;



// WEBPACK FOOTER //
// ./src/components/Rides.js